import React from "react";
import { Field } from "formik";
import { isMobile } from "react-device-detect";
import "./checkBox.css";

export default function CheckBox() {
  return (
    <>
      <div
        className={
          isMobile
            ? "new-latter-flex-mobile new-latter-flex"
            : "new-latter-flex"
        }
      >
        <label style={{ display: "flex", alignItems: "center" }}>
          <Field
            type="checkbox"
            name="newLetter"
            className={
              isMobile
                ? "news-latter-box-style news-latter-box-style-mobile"
                : " news-latter-box-style"
            }
          />
          <div className="new-latter-text">
            אני רוצה לקבל עדכונים ומידע שיווקי על תוכניות נוספות שמציעה מטח.
          </div>
        </label>
      </div>
    </>
  );
}
